<template>
  <div>
    <div :key="editForm.id">
      <div class="flex">
        <h2>{{ editForm.label }}设置</h2>
        <div @click="chooseRow" v-if="editForm.col" class="chooseRowClass">
          选中当前整行
        </div>
      </div>
      <el-form ref="form" :model="editForm" label-width="100px">
        <el-form-item
          label="模板"
          v-if="
            editForm.label != 'main' &&
            editForm.label != 'row' &&
            templateDiv.objectType == '组合'
          "
        >
          <el-select
            v-model="editForm.relationId"
            placeholder="请选择模板"
            @change="changeRelation"
          >
            <el-option
              v-for="item in templateOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="模板属性"
          v-if="editForm.label == 'main' && templateDiv.objectType != '组合'"
        >
          <el-select
            v-model="editForm.objectId"
            placeholder="请选择模板属性"
            @change="changeGoods"
          >
            <el-option
              v-for="item in goodsOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="接口"
          v-if="editForm.label == 'main' && templateDiv.objectType == '分页'"
        >
          <el-input
            placeholder="请输入接口"
            v-model="editForm.event"
            @change="changeParam('event', editForm.event)"
          >
            <el-button
              slot="append"
              icon="el-icon-question"
              @click="showEventTips"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label="元素属性"
          v-if="
            (editForm.label == 'rate' ||
              editForm.label == 'icon' ||
              editForm.label == 'div' ||
              editForm.label == 'image' ||
              editForm.label == 'video') &&
            templateDiv.objectType != '组合'
          "
        >
          <el-select
            v-model="editForm.label"
            placeholder="请选择元素属性"
            @change="changeType"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="矢量图"
          v-if="editForm.label == 'icon' && templateDiv.objectType != '组合'"
        >
          <el-select
            v-model="editForm.icon"
            placeholder="请选择元素属性"
            @change="changeType"
          >
            <el-option
              v-for="item in iconOptions"
              :key="item.name"
              :label="item.name"
              :value="item.remark"
            >
              <i
                :class="item.remark"
                class="yh-iconfont"
                style="font-size: 12px"
                >{{ item.remark }}</i
              >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="绑定字段"
          v-if="
            (editForm.label == 'rate' ||
              editForm.label == 'list' ||
              editForm.label == 'div' ||
              editForm.label == 'image' ||
              editForm.label == 'video') &&
            templateDiv.objectType != '组合'
          "
        >
          <el-select
            filterable
            allow-create
            default-first-option
            v-model="editForm.attribute"
            placeholder="请选择绑定字段"
            @change="changeAttribute"
          >
            <el-option
              v-for="item in paramOptions"
              :key="item.remark"
              :label="item.name"
              :value="item.remark"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="激活字段"
          v-if="
            (editForm.label == 'icon' ||
              editForm.label == 'list' ||
              editForm.label == 'div' ||
              editForm.label == 'image' ||
              editForm.label == 'video') &&
            templateDiv.objectType != '组合'
          "
        >
          <el-select
            v-model="editForm.active"
            placeholder="请选择激活字段"
            @change="changeParam('active', editForm.active)"
          >
            <el-option
              v-for="item in activeOption"
              :key="item.remark"
              :label="item.remark"
              :value="item.remark"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="自定义字段"
          v-if="editForm.label == 'div' && editForm.attribute == 'custom'"
        >
          <el-input
            placeholder="请输入自定义字段"
            v-model="editForm.custom"
            @change="changeParam('custom', editForm.custom)"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="高度(px)"
          v-if="
            editForm.label == 'list' ||
            editForm.label == 'row' ||
            editForm.label == 'div' ||
            editForm.label == 'image' ||
            editForm.label == 'video'
          "
        >
          <el-input-number
            :min="1"
            placeholder=""
            v-model.number="editForm.height"
            @change="changeStyle('height')"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="补充class">
          <el-input
            v-model="editForm.className"
            @change="changeParam('className')"
          ></el-input>
        </el-form-item>
        <el-form-item label="宽度(px)">
          <el-input-number
            :max="1600"
            :min="1"
            v-model.number="editForm.width"
            @change="changeStyle('width')"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="圆角(px)"
          v-if="
            (editForm.label == 'div' ||
              editForm.label == 'main' ||
              editForm.label == 'image' ||
              editForm.label == 'video') &&
            templateDiv.objectType != '组合'
          "
        >
          <el-input-number
            :min="0"
            v-model.number="editForm.borderRadius"
            @change="changeStyle('borderRadius')"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="内间距(px)"
          v-if="
            (editForm.label == 'list' ||
              editForm.label == 'row' ||
              editForm.label == 'icon' ||
              editForm.label == 'main' ||
              editForm.label == 'div') &&
            (editForm.label == 'main' || templateDiv.objectType != '组合')
          "
        >
          <el-input-number
            :min="0"
            :max="400"
            v-model.number="editForm.padding"
            @change="changeStyle('padding')"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="上外边距(px)" v-if="editForm.label != 'row'">
          <el-input-number
            :max="400"
            v-model.number="editForm.marginTop"
            @change="changeStyle('marginTop')"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="左外边距(px)"
          v-if="
            editForm.label == 'list' ||
            editForm.label == 'row' ||
            editForm.label == 'icon' ||
            editForm.label == 'div' ||
            editForm.label == 'image' ||
            editForm.label == 'video'
          "
        >
          <el-input-number
            v-model.number="editForm.marginLeft"
            @change="changeStyle('marginLeft')"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="字体大小(px)"
          v-if="
            (editForm.label == 'icon' || editForm.label == 'div') &&
            templateDiv.objectType != '组合'
          "
        >
          <el-input-number
            :min="12"
            :max="60"
            v-model.number="editForm.fontSize"
            @change="changeStyle('fontSize')"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="字体颜色"
          v-if="
            (editForm.label == 'icon' || editForm.label == 'div') &&
            templateDiv.objectType != '组合'
          "
        >
          <el-color-picker
            v-model="editForm.color"
            @change="changeStyle('color')"
          ></el-color-picker>
        </el-form-item>
        <el-form-item
          label="背景颜色"
          v-if="
            editForm.label == 'list' ||
            editForm.label == 'row' ||
            editForm.label == 'icon' ||
            editForm.label == 'main' ||
            editForm.label == 'div'
          "
        >
          <el-color-picker
            v-model="editForm.background"
            @change="changeStyle('background')"
          ></el-color-picker>
        </el-form-item>
        <el-form-item
          label="字体粗细"
          v-if="editForm.label == 'div' && templateDiv.objectType != '组合'"
        >
          <el-select
            v-model="editForm.fontWeight"
            placeholder="请选择字体粗细"
            @change="changeStyle('fontWeight')"
          >
            <el-option
              v-for="item in fontWeightOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="对齐方式"
          v-if="
            editForm.label == 'icon' ||
            (editForm.label == 'div' && templateDiv.objectType != '组合')
          "
        >
          <el-select
            v-model="editForm.textAlign"
            placeholder="请选择对齐方式"
            @change="changeStyle('textAlign')"
          >
            <el-option
              v-for="item in textAlignOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="添加事件"
          v-if="
            editForm.label != 'row' &&
            editForm.label != 'list' &&
            templateDiv.objectType != '组合'
          "
        >
          <el-select
            clearable
            v-model="editForm.methods"
            placeholder="请选择添加事件"
            @change="changeMethods"
            v-if="templateDiv.objectType != '组合'"
          >
            <el-option
              v-for="item in methodsOptions"
              :key="item.name"
              :label="item.label"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="弹窗模板"
          v-if="
            editForm.label != 'row' &&
            editForm.label != 'icon' &&
            editForm.label != 'list' &&
            templateDiv.objectType != '组合' &&
            editForm.methods == '弹窗'
          "
        >
          <el-select
            clearable
            v-model="editForm.frameId"
            placeholder="请选择弹窗模板"
            @change="changeParam('frameId', editForm.frameId)"
          >
            <el-option
              v-for="item in templateOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="悬停模板"
          v-if="editForm.label == 'main' && templateDiv.objectType != '组合'"
        >
          <el-select
            clearable
            v-model="editForm.templateId"
            placeholder="请选择悬停模板"
            @change="changeTemplateId"
          >
            <el-option
              v-for="item in templateOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="css补充">
          <el-input
            type="textarea"
            v-model="editForm.css"
            @blur="changeStyle(editForm.css)"
            onkeyup="this.value=this.value.replace(/[\r\n]/g,'')"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer" v-if="$route.query.type != '广告'">
        <el-button
          type="primary"
          v-if="editForm.label == 'main'"
          @click="addDiv('div')"
          >添加元素</el-button
        >
        <el-button
          type="primary"
          v-if="editForm.label == 'main'"
          @click="addRow"
          >添加栅格</el-button
        >

        <el-button
          type="danger"
          v-if="editForm.label != 'main'"
          @click="deleteBtn"
          >删除</el-button
        >
      </div>
      <div class="footer">
        <el-button
          type="primary"
          v-if="editForm.label == 'main'"
          @click="saveBtn(false)"
          >保存模板</el-button
        >
        <el-button
          type="primary"
          v-if="editForm.label == 'main' && templateId"
          @click="saveBtn(true)"
          >另存模板</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    templateId: String,
    templateDiv: Object,
    editForm: Object,
    goodsOptions: Array,
    paramOptions: Array,
    chooseSubIndex: null,
  },
  watch: {
    chooseSubIndex (val) {
      if (val) {
        this.typeOptions = [
          { value: "div", label: "文本" },
          { value: "image", label: "图片" },
          { value: "video", label: "视频" },
          { value: "icon", label: "矢量图" },
          { value: "rate", label: "评分" },
        ];
      } else {
        this.typeOptions = [
          { value: "div", label: "文本" },
          { value: "image", label: "图片" },
          { value: "video", label: "视频" },
          { value: "icon", label: "矢量图" },
          { value: "list", label: "列表" },
          { value: "rate", label: "评分" },
        ];
      }
    },
  },
  data () {
    return {
      activeOption: [],
      templateOptions: [],
      methodsOptions: [
        { name: "点赞", label: "点赞" },
        { name: "收藏", label: "收藏" },
        { name: "跳转", label: "跳转" },
        { name: "新窗口跳转", label: "新窗口跳转" },
        { name: "弹窗", label: "弹窗" },
        { name: "点击", label: "点击" },
        { name: "关闭弹窗", label: "关闭弹窗" },
      ],
      typeOptions: [
        { value: "div", label: "文本" },
        { value: "image", label: "图片" },
        { value: "video", label: "视频" },
        { value: "icon", label: "矢量图" },
        { value: "list", label: "列表" },
        { value: "rate", label: "评分" },
      ],
      iconOptions: [],
      fontWeightOptions: [
        { value: undefined, label: "正常" },
        { value: "bold", label: "加粗" },
      ],
      textAlignOptions: [
        { value: "left", label: "左对齐" },
        { value: "right", label: "右对齐" },
        { value: "center", label: "居中" },
      ],
    };
  },
  methods: {
    showEventTips () {
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("span", null, "pageSize - "),
          h("span", null, "个数 - "),
          h("span", { style: "color: red;font-weight:bold" }, "必传"),
          h("span", null, ",int类型"),
          h("p", null, ""),
          h("span", null, "pagination - "),
          h("span", null, "页码  - "),
          h("span", null, "0关1开"),
          h("p", null, ""),
          h("span", null, "showFindDirection - "),
          h("span", null, "showFindDirection组件  - "),
          h("span", null, "true开"),
        ]),
        confirmButtonText: "确定",
      }).then((action) => { });
    },
    //获取模板list
    getTemplateOptions () {
      this.api.template
        .pageList({
          pageNumber: 1,
          pageSize: 1000,
        })
        .then((result) => {
          this.templateOptions = result.data.records;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getActiveOption () {
      this.api.dictionary
        .getDictionaryListByParentId({ parentId: "1419930101482549249" })
        .then((res) => {
          this.activeOption = res.data;
        });
    },
    getIconOption () {
      this.api.dictionary
        .getDictionaryListByParentId({ parentId: "1423211778462101506" })
        .then((res) => {
          this.iconOptions = res.data;
        });
    },
    //更改组合模板
    changeRelation (val) {
      this.$emit("changeRelation", val);
    },
    //更改模板属性
    changeGoods (val) {
      this.goodsOptions.forEach((item) => {
        if (item.id == val) {
          this.$emit("getParamOptions", val, item.name);
        }
      });
    },
    //更改绑定字段
    changeAttribute (val) {
      this.paramOptions.forEach((item) => {
        if (this.paramOptions.some((item) => item.name == val)) {
          if (item.remark == val) {
            this.$emit("changeAttribute", val, item.name);
          }
        } else {
          this.$emit("changeAttribute", val, val);
        }
      });
    },
    changeParam (param, val) {
      this.$emit("changeParam", param);
    },
    //更改点击方法
    changeMethods (type) {
      if (type == "跳转" || type == "新窗口跳转") {
        this.$prompt("请输入跳转地址", "提示", {
          confirmButtonText: "确定",
          inputPattern: /\S/,
          inputErrorMessage: "跳转地址不能为空",
          showCancelButton: false,
        })
          .then(({ value }) => {
            this.$emit("changeMethod", "methods", type, value);
          })
          .catch(() => { });
      } else {
        this.$emit("changeMethod", "methods", type);
      }
    },
    //更改绑定组件
    changeTemplateId (val) {
      this.$emit("changeTemplateId", val);
    },
    //加元素
    addDiv (val, arr) {
      this.$emit("addDiv", val, arr);
    },
    //加栅格
    addRow () {
      this.$prompt("输入任意数字,并逗号分隔,相加等于24。例如6,6,6,6", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let arr = value.split(",");
          let count = 0;
          arr.forEach((item) => {
            count += item * 1;
          });
          if (count != 24) {
            this.$message.error("加起来要24");
          } else {
            this.addDiv("row", arr);
          }
        })
        .catch(() => { });
    },
    //改变style
    changeStyle (val) {
      this.$emit("changeStyle", val);
    },
    //改变元素类型
    changeType () {
      this.$emit("changeType");
    },
    //删除
    deleteBtn () {
      let that = this;
      this.$confirm("此操作将永久删除该元素, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("deleteElement");
        })
        .catch(() => { });
    },
    saveBtn (bol) {
      this.$emit("saveBtn", bol);
    },
    chooseRow () {
      this.$emit("chooseRow");
    },
  },
  mounted () {
    this.getTemplateOptions();
    this.getActiveOption();
    this.getIconOption();
  },
};
</script>
<style scoped>
.footer {
  display: flex;
  padding: 40px 40px 0 40px;
  box-sizing: border-box;
  justify-content: space-around;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
}
.chooseRowClass {
  margin-left: 20px;
  font-size: 12px;
  color: rgb(14, 156, 238);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineTemplate/template/editPanel.vue